import type { FaireProductEntity } from "../../entity_types/product";

export const p_gz5gmzu256: FaireProductEntity = {
  token: "p_gz5gmzu256",
  type: "product",
  name: "CROPPED ACTIVE JACKET",
  brandToken: "b_77bnfe2w2i",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c2bad00e300e8421014e0eaae51416e7eb92396b4620c6b184a2be076aa551e2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/adaccadc0cb872a36c29d5b6151fcdecb38864c0652a6dd9eace70151b33c0b8.jpeg",
    "https://cdn.faire.com/fastly/cf0a2be359a45970f779eed016a40a76b6926da7619522fcb3a7b11bd2dd187e.jpeg",
    "https://cdn.faire.com/fastly/6a1db2fb55b6e725abaac8e1466bc66142a5ca71d820c0da9a1053ce7d0c1b36.jpeg",
    "https://cdn.faire.com/fastly/4327a421e52c1d0d4e371dde9d1a1ddab58374febfb67b734d878389a59d2777.jpeg",
    "https://cdn.faire.com/fastly/119d43744e197a5bd9427028f1a59ab1d21315ed18d0592fc1fecda4887f226f.jpeg",
    "https://cdn.faire.com/fastly/5a8078b8d547d6eccd6d36ddf2eb1cf56e16f87fc6b40a179eda4faa35e40164.jpeg",
    "https://cdn.faire.com/fastly/05cc2deaa29fe0693b776295168976dfabc660a375713677cc0d296249dbe010.jpeg",
    "https://cdn.faire.com/fastly/18734cf5d64f5ffb7a2c19a805bb193c14d8deb538aabace5105db611b0a6831.jpeg",
    "https://cdn.faire.com/fastly/77973db1db0585d9373aadaa67b56dc059a7a07382d65f49c4de4c49c7da63d3.jpeg",
    "https://cdn.faire.com/fastly/5e012e9d25bdcfaf59fb626a4c6bd4847fbffd34619caa2c4862c5b33b556593.jpeg",
    "https://cdn.faire.com/fastly/da12807ce046a80c75cbd1f53a97da245fa4e454a28a618f807c018d2c5e24e6.jpeg",
    "https://cdn.faire.com/fastly/330c49b71fe5abd630acde4c27e8b4a222dd2c60cfe1a2a29dfff18116e9dd94.jpeg",
    "https://cdn.faire.com/fastly/7daa9660b08357047d99cd4673a055a6b30b36c67464c77b8692943a470dba0f.jpeg",
    "https://cdn.faire.com/fastly/99d37e33c7f2827bfded3cb6bb843b26feb3cd18e0cadf0a6995e5812974e8e1.jpeg",
    "https://cdn.faire.com/fastly/d4f9d6048717ea2496fa8553fe6a542cecc577aed88f3d563cabb60f0d64c470.jpeg",
    "https://cdn.faire.com/fastly/9d80a0a7e084c85a0fa0fb62b8a42dea0729f8d35f9cc7ec3d3b7e42b52ac87a.jpeg",
    "https://cdn.faire.com/fastly/b19aa7ac666eca97ee3d26c1843d0e0d871109c699f9aab5c37c939514c6e18c.jpeg",
    "https://cdn.faire.com/fastly/8e5f8ca6854cd8b6eff7f4c9dd9bd7f0ffe29844cea4536a2a45684b0f489320.jpeg",
    "https://cdn.faire.com/fastly/e1e1fac9ad13e26678d0c483726460c79d965d58b3206de943d8ae79fb4b16d4.jpeg",
    "https://cdn.faire.com/fastly/f09600ab04be529cd317549c41493d9297ec8668840293dedb83d4aabad5362a.jpeg",
    "https://cdn.faire.com/fastly/421a9765f1e133943def6db8867015bf36be7cd889726328db73ceb8eecc1818.jpeg",
    "https://cdn.faire.com/fastly/887ac35f106279fc9f5d6921838b6469acf7d724d9b5dc2cfeff1aa13cc820ad.jpeg",
    "https://cdn.faire.com/fastly/16169edcdcad52f3fb7e801c308d6e660be5f7807701343e45e9c3b86e63a933.jpeg",
    "https://cdn.faire.com/fastly/0fbb8e3520d4d7d3d3c1038c56153b52f41665e7ec30a1e09fa3982f4f374ac3.jpeg",
    "https://cdn.faire.com/fastly/45daabc72c6ed36476cf0f73f6a4e4ede448e9d15dc877c3e422fc6bcbc27f4c.jpeg",
    "https://cdn.faire.com/fastly/d19d4646eee8cd6f2bad23bf46b699dda2bd5bf146910f6309d6353b4d816f6c.jpeg",
    "https://cdn.faire.com/fastly/12191d531f05710410ed9af3634d65240274da3409cac5020c827fe8677ef431.jpeg",
    "https://cdn.faire.com/fastly/923136121957f0743c1c13f25dbcbe800e9a4eeefee1a4656532e63b1eae487d.jpeg",
    "https://cdn.faire.com/fastly/896b1199efec0b50ad11240685077d5c60398a1fbd4401edce1e18d2ff476f7d.jpeg",
  ],
  priceDollars: 29.79,
  description:
    "- Style No.: J3808\n\nThis active jacket is made from lightweight and cooling fabric, perfect for hiking and adventures year-round. Designed for active lifestyles, it offers breathable comfort beyond the summer season.\n\nFeatures:\n-\tLightweight and cooling fabric\n-\tRelaxed fit\n-\tSlightly cropped length\n-\tPullover jacket\n-\tQuarter zipper closure\n-\tMock neck\n-\tCinched sleeve / Long sleeve\n-\tCinchable hem with elastic string\n-\tKangaroo pocket\n-\tSeaming details\n\nAlso Available in Plus/Curvy Size 1XL-2XL-3XL\nStyle# J3808PL\n\nModel is 5'8\" and wearing size Small.\n\nFabric: 88% Polyester, 12% Spandex\nC.O.O: Import\n",
  tags: [],
  msrpDollars: 59.58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:46.235Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
